var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJourneyrightcurve(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 171,
    height: 470,
    viewBox: "0 0 171 470",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M171 310L1 310",
    stroke: "url(#paint0_linear_103_9502)",
    strokeOpacity: 0.64,
    strokeWidth: 12
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M171 464V464C141.022 464 113.671 446.898 100.545 419.947L67.5789 352.255C54.9889 326.404 28.7542 310 1.34631e-05 310V310",
    stroke: "url(#paint1_linear_103_9502)",
    strokeOpacity: 0.64,
    strokeWidth: 12
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M171 162V162C140.943 162 113.437 178.897 99.8506 205.708L68.2454 268.076C55.2131 293.793 28.8305 310 -1.29386e-05 310V310",
    stroke: "url(#paint2_linear_103_9502)",
    strokeOpacity: 0.64,
    strokeWidth: 12
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M41 6V6C57.5685 6 71 19.4315 71 36L71 239C71 278.212 39.2122 310 -2.65765e-05 310V310",
    stroke: "url(#paint3_linear_103_9502)",
    strokeOpacity: 0.64,
    strokeWidth: 12
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_103_9502",
    x1: 166.66,
    y1: 310,
    x2: 4.97873,
    y2: 310,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C17400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C10097"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_103_9502",
    x1: 171,
    y1: 464,
    x2: -0.00000933759,
    y2: 310,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C17400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C10097"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_103_9502",
    x1: 171,
    y1: 159.5,
    x2: -0.0000893434,
    y2: 310,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C17400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C10097"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_103_9502",
    x1: 36,
    y1: 2,
    x2: -0.000265081,
    y2: 310,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C17400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C10097"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJourneyrightcurve);
export default __webpack_public_path__ + "97120/static/media/Journey right curve.344887893d2e711e114041347c53bd7e.svg";
export { ForwardRef as ReactComponent };